import Aenume from '@/components/Aenume';
import AformItem from '@/components/AformItem';
import Apages from '@/components/Apages';
import './index.css';

export default {
  name: 'Ctable',
  components: {
    Aenume,
    AformItem,
    Apages,
  },
  props: {
    rowKey: { type: String, default: () => 'id' },
    size: { type: String, default: () => 'medium' },
    sort: { type: Boolean, default: () => true },
    border: { type: Boolean, default: () => false },
    stripe: { type: Boolean, default: () => false },
    column: { type: Array, default: () => [] },
    record: { type: Object, default: () => ({}) },
    params: { type: Object, default: () => ({}) },
    selection: { type: Boolean, default: () => false },
    showOverflowTooltip: { type: Boolean, default: () => true },
    sortable: { type: Boolean, default: () => false },
    defaultSort: { type: Object, default: () => ({ prop: 'date', order: 'descending' }) },
    tree: { type: Boolean, default: () => false },
    defaultExpandAll: { type: Boolean, default: () => true },
    treeProps: { type: Object, default: () => ({ children: 'children', hasChildren: 'hasChildren' }) },
    actionWidth: { type: String, default: () => '180px' },
    actionTitle: { type: String, default: () => '操作' },
    formatTime: { type: Boolean, default: () => true },
    preview: { type: Boolean, default: () => false },
    page: { type: Boolean, default: () => true },
  },
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.search();
    this.create();
  },
  mounted() {
    this.$refs['c-table'].bodyWrapper.addEventListener('scroll', this.scroll);
  },
  destroyed() {
    this.$refs['c-table'].bodyWrapper.removeEventListener('scroll', this.scroll);
  },
  methods: {
    create(column = []) {
      if (this.formatTime && this.column.length > 0) {
        for (let a in this.column) {
          if (this.column[a].field && this.column[a].field.toLowerCase().includes('time')) {
            this.column[a].render = (item) => item[this.column[a].field] != '' && this.filter(item[this.column[a].field]);
          }
        }
      }
      const actionColumn = () => {
        let data = [];
        const { review, modify, update, handle, remove } = this.$listeners;
        if (review || modify || update || handle || remove || this.$listeners.delete || this.$listeners.export) {
          data = [{
            label: this.actionTitle,
            fixed: 'right',
            align: 'center',
            width: this.actionWidth,
            render: (item) => (
              <div class="action">
                {review && <i class="el-icon-view" on-click={() => review(item)} />}
                {modify && <i class="el-icon-edit" on-click={() => modify(item)} />}
                {update && <i class="el-icon-edit" on-click={() => update(item)} />}
                {handle && <i class="el-icon-edit" on-click={() => handle(item)} />}
                {remove && <Apopconfirm on-submit={() => remove(item)} />}
                {this.$listeners.delete && <Apopconfirm on-submit={() => this.$listeners.delete(item)} />}
                {this.$listeners.export && <i class="el-icon-download" on-click={() => this.$listeners.export(item)} />}
              </div>
            ),
          }];
        }
        return data;
      }
      const columnConfig = [...column, ...actionColumn()];
      return columnConfig.map((a, b) => {
        if (a) return (
          <el-table-column
            key={b}
            prop={a.field}
            showOverflowTooltip={this.showOverflowTooltip}
            sortable={a.field ? (a.sortable ? a.sortable : this.sortable) : false}
            formatter={a.formatter ?
              (e, f, g, h) => a.formatter(e, h)
              :
              (a.render ? ((e, f, g, h) => a.render(e, h)) : (a.type ? (e, f, g, h) => this.format(a, b, e, h) : null))
            }
            {...{ props: a }}
          />
        )
      });
    },
    search() {
      const { pageParams, formParams } = this.$store.state;
      const params = Object.assign({}, pageParams, formParams, this.params);
      this.$emit('search', params);
    },
    filter(timeStamp) {
      if (!typeof timeStamp == Number) return '';
      let time = new Date(timeStamp)
      const YYYY = time.getFullYear();
      const MM = ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1));
      const DD = (time.getDate() < 10 ? '0' + time.getDate() : time.getDate());
      const H = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
      const M = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
      const S = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
      return YYYY + '-' + MM + '-' + DD + ' ' + H + ':' + M + ':' + S;
    },
    select(items) {
      this.$store.commit('setSelectedRows', items);
      this.$store.commit('setSelectedKeys', items.map(a => a[this.rowKey]));
      this.$emit('select', { rows: items, keys: items.map(a => a[this.rowKey]) });
    },
    choose(row, column, event) {
      this.$emit('choose', { row, column, event });
    },
    change(pages = { page: 1, size: 10 }) {
      this.$store.commit('setPageParams', pages);
      this.$emit('change', pages);
      this.search(pages);
    },
    switch(name = '', symbol = '_') {
      return name.replace(/([A-Z])/g, `${symbol}$1`).toLowerCase();
    },
    format({ label, field, type, disabled, action = '', path = '', flag = '', ...props }, colIndex, item, rowIndex) {
      if (this.preview && (type != 'select' || type != 'enume' || type != 'enumerate')) return <span key={colIndex + '-' + rowIndex}>{item[field]}</span>;
      if (type == 'select' || type == 'enume' || type == 'enumerate') {
        let dicts = [];
        if (this.optionApi != '' || action != '' || path != '') {
          let url = action != '' ? action : (path != '' ? path : this.optionApi);
          let params = flag != '' ? { flag: this.switch(flag) } : { field: this.switch(field) };
          FN.get(url, params).then(({ data }) => {
            if (data && data.length > 0) dicts = data;
          });
        }
        return <Aenume key={colIndex + '-' + rowIndex} v-model={item[field]} field={`${field}`} data={dicts} {...props} />
      }
      return <AformItem key={colIndex + '-' + rowIndex} config={{ type, form: item, label, field: `${field}`, dicts, table: true, ...props }} />
    },
    scroll({ target }) {
      this.$emit('scroll', target);
    },
  },
  render() {
    const { data = [], size = 0 } = this.record;
    const { pageParams } = this.$store.state;
    const condition = data && data.length > 0;
    const { ...attrs } = this.$attrs;
    return (
      <div class="c-table" v-loading={this.loading}>
        <el-table
          ref="c-table"
          data={data}
          size={this.size}
          border={this.border}
          stripe={this.stripe}
          column={this.column}
          row-key={this.rowKey}
          on-row-click={this.choose}
          default-sort={this.defaultSort}
          on-selection-change={this.select}
          tree-props={this.tree ? this.treeProps : {}}
          default-expand-all={this.defaultExpandAll}
          {...{ attrs }}
        >
          {condition && this.selection && <el-table-column fixed="left" type="selection" width="50" />}
          {condition && this.sort && <el-table-column fixed="left" type="index" width="50" label="#" />}
          {condition && this.create(this.column)}
        </el-table>
        {!this.tree && this.page && condition && (
          <Apages total={Number(size)} pages={pageParams} on-change={this.change} />
        )}
      </div>
    );
  }
}